import { Box } from "@mui/material";
import ReactMarkdown from 'react-markdown';


export interface ChatMessageProps {
    text: string;
    sender: 'User' | 'System';
};

export const ChatMessage = (props: ChatMessageProps) => {
    const { text, sender } = props;

    return (
        <Box
            sx={{
                bgcolor: sender === "User" ? "#434d54" : "#E5E5EA",
                color: sender === "User" ? "white" : "black",
                px: 2,
                borderRadius: "18px",
                maxWidth: "75%",
                display: "inline-block",
            }}
        >
            <p> <ReactMarkdown>{text}</ReactMarkdown></p>
        </Box>
    );
}
